export default __webpack_public_path__ + "static/media/button_back_arrow.55542c7c.svg";